'use client'

import SignUpForm from '@/components/forms/SignUpForm'
import { freePitch } from '@/constants/plans'

// The site's one call to action, inline in the ranked list. It sat in the left
// rail until 2026-09-21; with the rail gone, the list is the only surface a
// reader scrolls, so the ask belongs in it. Newspaper subscription-box
// treatment (square, heavy ink rule) so it reads as a different KIND of thing
// from the stories either side of it and is never mistaken for a headline.
// `standalone` renders it outside a list (after the feed) instead of as a
// list row. The email field is inline; the header keeps its button + modal.
// The mocks' card (2026-11-01): a serif "Both sides, every morning" with the
// helper line under it at the left, the email field and a solid Subscribe
// at the right, 18px by 22px of padding; the envelope icon went.
export default function SubscribeCard({
  location = 'now_inline',
  standalone = false,
  // Above a page's header instead of after its content: no top margin,
  // space below.
  top = false,
  // Replaces the wrapper's spacing classes (a caller that hides the card on
  // a phone and spaces the page itself).
  className = null,
  // The line under the heading, worded for the page it sits on (2026-11-01:
  // one card everywhere, only this line changes). The heading never does.
  pitch = null,
}) {
  const Wrapper = standalone ? 'div' : 'li'
  const spacing =
    className ??
    (top
      ? 'mb-8'
      : standalone
        ? 'mt-8'
        : 'list-none border-b border-border py-5')
  return (
    <Wrapper className={spacing}>
      <div className="flex flex-wrap items-center gap-x-7 gap-y-3.5 border border-foreground bg-card px-[22px] py-[18px]">
        <div className="min-w-0 flex-[999_1_320px]">
          <h2 className="font-serif text-[19px] font-normal leading-snug text-foreground">
            Both sides, every morning
          </h2>
          <p className="mt-[3px] font-sans text-[13px] leading-snug text-muted-foreground">
            {/* The free plan in one line (2026-11-01): the newsletter plus
                the stories that make signing up worth it on the site. */}
            {pitch || freePitch()}
          </p>
        </div>
        {/* The email field right here (2026-09-30): the button used to open
            a modal, a step between the pitch and the field that most
            visitors never took. The 6-digit code still verifies the address
            (bots), so the flow after this is unchanged. */}
        <SignUpForm
          card
          buttonLabel="Subscribe free"
          trackingLocation={location}
          className="min-w-0 flex-[1_1_340px]"
        />
      </div>
    </Wrapper>
  )
}
